enum events {
    WIDGET_POSITION_TOGGLE = 'WIDGET_POSITION_TOGGLE',
    INIT_FRESHCHAT = 'INIT_FRESHCHAT',
    INIT_FRESHCHAT_IMPLEMENTATION_BANNER = 'INIT_FRESHCHAT_IMPLEMENTATION_BANNER',
    FRESHCHAT_WIDGET_VISIBILITY = 'FRESHCHAT_WIDGET_VISIBILITY',
}

export default events
  